<div class="tenant-shell">
  <header class="tenant-shell__header">
    <div class="tenant-shell__left">
      <div class="tenant-shell__brand">{{ 'pages.dashboard.brand' | translate }}</div>
      @if (showBackButton) {
        <a
          class="btn btn-ghost btn-sm tenant-shell__back"
          [routerLink]="backRoute"
          >
          {{ 'pages.dashboard.back_to_dashboard' | translate }}
        </a>
      }
    </div>
    <div class="tenant-shell__actions">
      @if (tenantLabel) {
        <span class="tenant-shell__tenant">{{ tenantLabel }}</span>
      }
      <div class="tenant-shell__notifications" #notificationsMenuHost>
        <a
          class="tenant-shell__notifications-link"
          [class.tenant-shell__notifications-link--active]="isNotificationsTriggerActive()"
          href="/notifications"
          [attr.aria-label]="'pages.notifications.list.title' | translate"
          [attr.aria-expanded]="isNotificationsMenuOpen"
          aria-haspopup="menu"
          (click)="onNotificationsTriggerClick($event)"
          >
          <span class="tenant-shell__notifications-label">{{ 'pages.notifications.list.title' | translate }}</span>
          @if (notificationStore.unreadCount() > 0) {
            <span class="tenant-shell__notifications-badge" aria-hidden="true">{{ notificationStore.unreadCount() }}</span>
          }
        </a>

        @if (isNotificationsMenuOpen) {
          <div class="tenant-shell__notifications-menu" role="menu">
            @if (isLoadingUnreadPreview) {
              <div class="tenant-shell__notifications-loading">{{ 'common.loading' | translate }}</div>
            } @else if (unreadPreviewError) {
              <div class="tenant-shell__notifications-error">{{ unreadPreviewError | translate }}</div>
              <button
                type="button"
                class="btn btn-outline btn-sm"
                (click)="refreshUnreadPreview($event)"
                >
                {{ 'common.buttons.retry' | translate }}
              </button>
            } @else {
              <ul class="tenant-shell__notifications-list">
                @for (item of unreadPreviewItems; track item.id) {
                  <li>
                    <a
                      class="tenant-shell__notifications-item"
                      [routerLink]="['/notifications', item.id]"
                      (click)="closeNotificationsMenu()"
                      >
                      <span class="tenant-shell__notifications-item-title">{{ resolveUnreadPreviewTitle(item) }}</span>
                      <span class="tenant-shell__notifications-item-time">{{ item.notification_created_at | date: 'short' }}</span>
                    </a>
                  </li>
                }
              </ul>
            }

            <button
              type="button"
              class="tenant-shell__notifications-more"
              (click)="openNotificationsCenter($event)"
              >
              {{ 'common.buttons.show_more' | translate }}
            </button>
          </div>
        }
      </div>
      @if (currentUser) {
        <a class="tenant-shell__user-link" routerLink="/profile">
          {{ getUserDisplayName() }}
        </a>
      }
      <button class="btn btn-outline btn-sm" (click)="logout()">
        {{ 'pages.dashboard.logout' | translate }}
      </button>
    </div>
  </header>

  <main class="tenant-shell__main">
    @if (breadcrumbs.length > 0) {
      <nav class="tenant-shell__breadcrumbs">
        @for (crumb of breadcrumbs; track crumb; let isLast = $last) {
          @if (crumb.url) {
            <a
              class="tenant-shell__breadcrumb-link"
              [routerLink]="crumb.url"
              >
              {{ crumb.labelKey | translate }}
            </a>
          } @else {
            <span class="tenant-shell__breadcrumb-current">{{ crumb.labelKey | translate }}</span>
          }
          @if (!isLast) {
            <span class="tenant-shell__breadcrumb-separator">/</span>
          }
        }
      </nav>
    }
    <ng-content></ng-content>
  </main>

  <footer class="tenant-shell__footer">
    <span class="tenant-shell__footer-version">{{ 'common.app_version' | translate: { version: appVersion } }}</span>
  </footer>
</div>
